<ptg-dialog
  class="update-property-dialog"
  [title]="'Edit Property'"
  [footerPosition]="'bottom'"
  [footerAlign]="'right'"
  [isFullScreen]="false"
  *ngIf="!isLoading"
>
  <ng-template dialogBody>
    <form class="edit-form overflow-y-auto" [formGroup]="editForm">
      <div class="property-config-info-container">
        <div class="property-config-container label-only mt-5">
          <span class="mt-23" *ngIf="isIdentifierPropertyType === false"
            >Data Type:
            <p class="config-data">
              {{
                propertyDetail?.type === EntityPropertyType.Employer
                  ? layoutService.employerLabel
                  : EntityPropertyType[propertyDetail?.type!]
              }}
            </p></span
          >
          <span class="mt-23" *ngIf="isIdentifierPropertyType === true"
            >Property Type:
            <p class="config-data">Identifier</p></span
          >
          <span *ngIf="isShowEncrypted || isIdentifierPropertyType === false" class="mgt-16"
            >Encrypted:
            <p class="config-data">
              {{ isEncrypted ? 'On' : 'Off' }}
            </p></span
          >
          <span *ngIf="isShowUnique || isIdentifierPropertyType === false" class="mgt-16"
            >Unique:
            <p class="config-data">
              {{ isUnique ? 'On' : 'Off' }}
            </p></span
          >
          <span
            *ngIf="propertyDetail?.type === EntityPropertyType.Lookup || isIdentifierPropertyType === false"
            class="mgt-16"
            >Lookup Table:
            <p class="config-data">
              {{ currentLookupTable }}
            </p></span
          >
        </div>
        <ptg-textbox
          [controlField]="nameCtrl"
          [maxLength]="250"
          placeholder="Name"
          [hasLabel]="true"
          [isRequired]="true"
          errorAsync="Property Name or Import Label already exists."
        ></ptg-textbox>
      </div>

      <!-- Used for Identifier Property Type only -->
      <div class="identifier-property-container" *ngIf="isIdentifierPropertyType === true">
        <ptg-radio-button
          [controlField]="identifierTypeRadioCtrl"
          [listOption]="identifierTypeOptions"
          [isObject]="true"
          (changeValue)="onChangeIdentifierTypeRadio($event)"
          [isDisabled]="isIdentifierPropertyShouldBeGreyOut"
        ></ptg-radio-button>

        <div class="auto-generated-section" [ngClass]="{ 'hide-section': !identifierPropertyTypeIsAutoGenerated }">
          <p class="pattern-title"><b>Pattern</b></p>
          <div>
            <ptg-textbox
              class="full-width-textbox pattern"
              [controlField]="patternTextCtrl"
              [hasLabel]="false"
              [maxLength]="250"
              placeholder="Pattern"
              (valueChange)="onChangePattern()"
              [isDisabled]="isIdentifierPropertyShouldBeGreyOut"
              [pattern]="patternRegex"
              errorPattern="Pattern must contain at least one hash (#) character for incremental value."
              restrictedRegex="\s+"
              errorRequire="Pattern is required."
              errorMaxLength="Exceed the 250 character limit."
            ></ptg-textbox>
          </div>
          <div>
            <ptg-textbox
              class="full-width-textbox starting-value"
              [controlField]="startingValueTextCtrl"
              [hasLabel]="false"
              placeholder="Starting Value"
              [isDisabled]="isIdentifierPropertyShouldBeGreyOut"
              restrictedRegex="\D*"
              (onOutFocus)="validateStartingValue()"
              (valueChange)="validateStartingValue()"
              [maxLength]="250"
              errorMaxLength="Exceed the 250 character limit."
              customError="errorMessage"
            ></ptg-textbox>
          </div>
        </div>
      </div>
      <!-- End of use for Identifier Property only -->

      <div class="element-container">
        <div
          class="w-50"
          [ngClass]="{
            'hide-section': isIdentifierPropertyType === true && identifierPropertyTypeIsAutoGenerated === true
          }"
        >
          <div class="property-config-container">
            <ptg-toggle-button [controlField]="requiredConditionCtrl" label="Required"></ptg-toggle-button>
          </div>
          <div *ngIf="propertyDetail?.type !== EntityPropertyType.RichText" class="property-config-container">
            <ptg-toggle-button
              [controlField]="includeInBulkUpdateCtrl"
              (valueChange)="changeToggle($event, 'includeInBulkUpdate')"
              label="Enable Bulk Update"
              [isIncludeChild]="true"
            ></ptg-toggle-button>
            <ng-container *ngIf="includeInBulkUpdateCtrl?.value">
              <div
                class="input-container"
                [ngClass]="{
                  'error-margin-bottom': editForm.get('importLabel')?.touched && editForm.get('importLabel')?.errors
                }"
              >
                <ptg-textbox
                  [controlField]="importLabelCtrl"
                  [maxLength]="250"
                  [hasLabel]="true"
                  placeholder="Import Label"
                  [isRequired]="true"
                  errorAsync="Property Name or Import Label already exists."
                ></ptg-textbox>
              </div>
            </ng-container>
          </div>
          <ng-container *ngFor="let elementName of elementNames; let isOdd = odd">
            <ng-container
              *ngIf="isOdd"
              [ngTemplateOutlet]="propertyConfig"
              [ngTemplateOutletContext]="{ elementName: elementName }"
            ></ng-container>
          </ng-container>
        </div>
        <div
          class="w-50"
          [ngClass]="{
            'hide-section': isIdentifierPropertyType === true && identifierPropertyTypeIsAutoGenerated === true
          }"
        >
          <div
            [ngClass]="{
              'read-only': propertyDetail?.type !== EntityPropertyType.RichText,
              'identifier-adjustment': isIdentifierPropertyType === true
            }"
            class="property-config-container"
          >
            <ptg-toggle-button
              [controlField]="readOnlyConditionCtrl"
              (valueChange)="changeToggle($event, 'readOnly')"
              label="Read-Only"
            ></ptg-toggle-button>
          </div>
          <div *ngIf="showMasked" class="property-config-container only-masked">
            <ptg-toggle-button
              [controlField]="maskedConditionCtrl"
              (valueChange)="changeToggle($event, 'masked')"
              label="Masked"
            ></ptg-toggle-button>
          </div>
          <ng-container *ngFor="let elementName of elementNames; let isEven = even">
            <ng-container
              *ngIf="isEven"
              [ngTemplateOutlet]="propertyConfig"
              [ngTemplateOutletContext]="{ elementName: elementName }"
            ></ng-container>
          </ng-container>
        </div>
        <ng-template let-elementName="elementName" #propertyConfig>
          <ng-container [ngSwitch]="elementName">
            <ng-template ngSwitchCase="inclusiveInRange">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="inclusiveInRangeCtrl"
                  (valueChange)="changeToggle($event, 'inclusiveInRange')"
                  label="Inclusive in Range (min/max)"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <ng-container *ngIf="inclusiveInRangeCtrl?.value">
                  <div class="input-container double-input">
                    <ptg-textbox
                      [controlField]="minInputCtrl"
                      [hasLabel]="true"
                      placeholder="Min"
                      (onBlur)="markMinMaxAsTouched()"
                      inputType="Number"
                      [customValidator]="customValidators"
                      [showError]="false"
                    ></ptg-textbox>
                    <ptg-textbox
                      [controlField]="maxInputCtrl"
                      [hasLabel]="true"
                      (onBlur)="markMinMaxAsTouched()"
                      placeholder="Max"
                      inputType="Number"
                      [customValidator]="customValidators"
                      [showError]="false"
                    ></ptg-textbox>
                  </div>
                  <div class="error-container">
                    <mat-error
                      class="error-text"
                      *ngIf="
                        (minInputCtrl?.errors?.minHigherThanMax || maxInputCtrl?.errors?.minHigherThanMax) &&
                        !(
                          minInputCtrl?.errors?.min ||
                          minInputCtrl?.errors?.max ||
                          maxInputCtrl?.errors?.min ||
                          maxInputCtrl?.errors?.max
                        )
                      "
                    >
                      Max range must be higher than Min range.
                    </mat-error>
                    <mat-error
                      class="error-text"
                      *ngIf="
                        minInputCtrl?.errors?.min ||
                        minInputCtrl?.errors?.max ||
                        maxInputCtrl?.errors?.min ||
                        maxInputCtrl?.errors?.max
                      "
                    >
                      Range must be within the range of -2147483647 - 2147483647.
                    </mat-error>
                    <mat-error
                      class="error-text"
                      *ngIf="
                        (minInputCtrl?.errors?.required && minInputCtrl?.touched) ||
                        (maxInputCtrl?.errors?.required && maxInputCtrl?.touched)
                      "
                    >
                      Range is required.
                    </mat-error>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="maximumLength">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="maximumLengthCtrl"
                  (valueChange)="changeToggle($event, 'maximumLength')"
                  label="Maximum Length"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <ng-container *ngIf="maximumLengthCtrl?.value">
                  <div class="input-container">
                    <ptg-textbox
                      [controlField]="maxLengthInputCtrl"
                      [hasLabel]="true"
                      placeholder="Maximum Length"
                      [isDecimal]="false"
                      [isPositive]="true"
                      [allowZero]="false"
                      [isRequired]="true"
                      [min]="1"
                      [max]="2147483647"
                      inputType="Number"
                      [isStrict]="false"
                    ></ptg-textbox>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="fractionalLength">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="fractionalLengthCtrl"
                  (valueChange)="changeToggle($event, 'fractionalLength')"
                  label="Fractional Length"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <ng-container *ngIf="fractionalLengthCtrl?.value">
                  <div class="input-container">
                    <ptg-textbox
                      [controlField]="fractionalLengthInputCtrl"
                      [hasLabel]="true"
                      [isDecimal]="false"
                      [isPositive]="true"
                      placeholder="Fractional Length"
                      [isRequired]="true"
                      [min]="0"
                      [max]="10"
                      inputType="Number"
                      [isStrict]="false"
                    ></ptg-textbox>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="smsEnabled">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="smsEnabledCtrl"
                  (valueChange)="changeToggle($event)"
                  label="SMS Enabled"
                ></ptg-toggle-button>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="prefixList">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="prefixListCtrl"
                  (valueChange)="changeToggle($event, 'prefixList')"
                  label="Prefix List"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <div class="input-container">
                  <ptg-select
                    *ngIf="prefixListCtrl?.value"
                    placeholder="Lookup Table"
                    [controlField]="lookupTableCtrl"
                    [listData]="lookupTableOptions"
                    [isOptionObj]="true"
                    [isSetMaxWidthSelect]="true"
                  ></ptg-select>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="listValues">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="listValuesCtrl"
                  (valueChange)="changeToggle($event, 'listValues')"
                  label="Lookup Values"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <div class="input-container">
                  <ptg-select
                    *ngIf="listValuesCtrl?.value"
                    placeholder="Lookup Table"
                    [controlField]="lookupTableCtrl"
                    [listData]="lookupTableOptions"
                    [isOptionObj]="true"
                    [isSetMaxWidthSelect]="true"
                    customError="lookupEnabledError"
                  ></ptg-select>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="boolean">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="booleanCtrl"
                  (valueChange)="changeToggle($event, 'boolean')"
                  label="Display Values"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <ng-container *ngIf="booleanCtrl?.value">
                  <div class="input-container double-input">
                    <ptg-textbox
                      placeholder="Affirmative"
                      [controlField]="affirmativeCtrl"
                      [hasLabel]="true"
                      [showError]="false"
                      (onBlur)="markDisplayValueAsTouched()"
                      errorRequire="Affirmative value is required."
                    ></ptg-textbox>
                    <ptg-textbox
                      placeholder="Negative"
                      [controlField]="negativeCtrl"
                      [hasLabel]="true"
                      [showError]="false"
                      (onBlur)="markDisplayValueAsTouched()"
                      errorRequire="Negative value is required."
                    ></ptg-textbox>
                  </div>
                  <div class="error-container">
                    <mat-error
                      class="error-text"
                      *ngIf="affirmativeCtrl?.errors?.duplicateValue || negativeCtrl?.errors?.duplicateValue"
                    >
                      Affirmative and Negative are duplicated.
                    </mat-error>
                    <mat-error
                      class="error-text"
                      *ngIf="
                        (affirmativeCtrl?.errors?.required && affirmativeCtrl?.touched) ||
                        (negativeCtrl?.errors?.required && negativeCtrl?.touched)
                      "
                    >
                      Display value is required.
                    </mat-error>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="usedStateLookupTable">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="usedStateLookupTableCtrl"
                  (valueChange)="changeToggle($event, 'usedStateLookupTable')"
                  label="State/Province/Territory"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <div class="input-container">
                  <ptg-select
                    *ngIf="usedStateLookupTableCtrl?.value"
                    placeholder="State/Province/Territory"
                    [controlField]="stateLookupTableCtrl"
                    [listData]="lookupTableOptions"
                    [isOptionObj]="true"
                    [isSetMaxWidthSelect]="true"
                  ></ptg-select>
                </div>
              </div>
            </ng-template>
            <ng-template ngSwitchCase="usedCountryLookupTable">
              <div class="property-config-container">
                <ptg-toggle-button
                  [controlField]="usedCountryLookupTableCtrl"
                  (valueChange)="changeToggle($event, 'usedCountryLookupTable')"
                  label="Country"
                  [isIncludeChild]="true"
                ></ptg-toggle-button>
                <div class="input-container">
                  <ptg-select
                    *ngIf="usedCountryLookupTableCtrl?.value"
                    placeholder="Country"
                    [controlField]="countryLookupTableCtrl"
                    [listData]="lookupTableOptions"
                    [isOptionObj]="true"
                    [isSetMaxWidthSelect]="true"
                  ></ptg-select>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </ng-template>
      </div>

      <div *ngIf="propertyDetail?.type == EntityPropertyType.Date" class="date-validation">
        <div class="validationTitle">Define Validation Rule</div>

        <div class="element-container">
          <div class="w-50">
            <div class="property-config-container">
              <ptg-toggle-button
                [controlField]="excludeFutureDatesCtrl"
                (valueChange)="changeToggle($event, 'excludeFutureDates')"
                label="Exclude Future Dates"
              ></ptg-toggle-button>
              <ptg-toggle-button
                [controlField]="dateValidationCtrl"
                (valueChange)="changeToggle($event, 'dateValidation')"
                label="Validation"
              ></ptg-toggle-button>
            </div>
          </div>
          <div class="w-50">
            <div class="property-config-container padding-left-44">
              <ptg-toggle-button
                [controlField]="excludePastDatesCtrl"
                (valueChange)="changeToggle($event, 'excludePastDates')"
                label="Exclude Past Dates"
              ></ptg-toggle-button>
            </div>
          </div>
        </div>
        <div class="expressions">
          <ng-container formArrayName="dateExpressions">
            <ng-container *ngFor="let item of dateExpressions.controls; let i = index">
              <div class="form-control-container" [formGroupName]="i">
                <div class="flex" [class.style-item]="i">
                  <ptg-select
                    class="w-30 mr-4"
                    [controlField]="item.get('validation')"
                    [isOptionObj]="true"
                    [listData]="ValidationOptions"
                    placeholder="Validation Interval"
                    [isRequired]="true"
                  ></ptg-select>
                  <ptg-select
                    class="w-30 mr-4"
                    [controlField]="item.get('validationType')"
                    [isOptionObj]="true"
                    [listData]="ValidationTypeOptions"
                    placeholder="Validation Type"
                    [isRequired]="true"
                    (changeOptionValue)="refreshError(i)"
                  ></ptg-select>

                  <div class="w-30" [ngSwitch]="item?.value['validationType']">
                    <ptg-textbox
                      *ngSwitchCase="DateValidationType.Age"
                      [controlField]="item.get('value')"
                      [maxLength]="3"
                      placeholder="Age Limit"
                      [min]="1"
                      [max]="130"
                      errorMinMaxValue="The input has to be between 1 to 130."
                      [hasLabel]="true"
                      inputType="Number"
                      [isRequired]="true"
                      [isStrict]="false"
                      [isShowHintText]="true"
                      (onFocus)="ageLimitFieldFocus(item)"
                      (onOutFocus)="ageLimitFieldFocus(item)"
                    ></ptg-textbox>

                    <ptg-select
                      *ngSwitchCase="DateValidationType.Property"
                      [controlField]="item.get('value')"
                      [isOptionObj]="true"
                      [listData]="dataPropertylookupOptions"
                      placeholder="Data Property Lookup"
                      [isRequired]="true"
                    ></ptg-select>

                    <ptg-datepicker
                      *ngSwitchCase="DateValidationType.SpecificDate"
                      [controlField]="item.get('value')"
                      class="value-input-field"
                      [isRequired]="true"
                      [placeholder]="'Date Selection'"
                    >
                    </ptg-datepicker>
                  </div>
                  <ptg-button
                    *ngIf="dateExpressions.controls.length > 1"
                    (clickButton)="onClickRemoveExpression(i)"
                    buttonName=""
                    class="clear-style-btn"
                    classInput="delete-button text-gray"
                    [class.hidden-remove]="!i"
                  >
                    <mat-icon class="title-free">delete_forever</mat-icon>
                  </ptg-button>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <button
          mat-raised-button
          type="button"
          class="add-condition"
          (click)="onClickNewValidation()"
          [class.hidden-button]="hideAddNewButton()"
        >
          <mat-icon>add</mat-icon>
          New Validation
        </button>
      </div>
    </form>
  </ng-template>

  <ng-template dialogFooter>
    <button mat-raised-button type="button" class="submit" (click)="formSubmit$.next()">Save</button>
    <button mat-raised-button type="button" class="cancel" (click)="onClickCancel()">Cancel</button>
  </ng-template>
</ptg-dialog>
<div id="loading-check" class="is-loading-section" *ngIf="isLoading">
  <div class="wrap-item">
    <mat-progress-spinner role="progressbar" aria-label="Progress Spinner" diameter="50" mode="indeterminate">
    </mat-progress-spinner>
    <p>Loading...</p>
  </div>
</div>
